<template>
  <div id="berandablog">
    <div class="container-1056">
      <div class="card py-16 px-16 mt-16">
        <h1 class="title is-4 has-text-centered">{{actionTitle}} Blog</h1>
        <div class="rows">
          <div class="row">
            <b-field label="Title" expanded 
            :type="form.title.type" 
            :message="form.title.message">
              <b-input name="title" @input="clearError(form.title)" v-model="form.title.value"></b-input>
            </b-field>

            <p>Silahkan Isi Content Blog News
              <b-field 
              :type="form.news.type" 
              :message="form.news.message">
                <ckeditor
                  :editor="editor"
                  v-model="form.news.value"
                  :config="editorConfig"
                  @input="clearError(form.news)"
                ></ckeditor>
              </b-field>
          
            <br>
            <div class="rows">
            <div class="row">
              <div class="columns">
                <div class="column">
                  <b-field label="Gambar News 1"
                    :type="form.picture.type"
                    :message="form.picture.message"> 
                      <b-upload v-model="form.picture.value" @input="readImage"  accept="image/*" drag-drop>
                        <section class="section">
                          <div class="content has-text-centered">
                            <p v-if="upload">
                              <b-icon icon="upload" size="is-medium">
                              </b-icon>
                            </p>
                            <p v-if="upload">
                              Drop your files here or click to upload
                            </p>
                            
                            <div class="image-preview" v-if="preview">
                              <img class="preview" :src="gambarNews">
                            </div>
                            <div class="image-preview" v-if="previewEdit">
                              <img class="preview" :src="gambarNews">
                            </div>
                          </div>
                        </section>
                      </b-upload>
                  </b-field>

                  <div class="tags">
                    <span class="tag is-primary" v-if="preview">
                      {{ form.picture.value.name }}
                      <button
                        class="delete is-small"
                        type="button"
                        @click="deleteDropFile()"
                      ></button>
                    </span>

                    <span class="tag is-primary" v-if="previewEdit">
                      {{ form.picture.value }}
                      <button
                        class="delete is-small"
                        type="button"
                        @click="deleteDropFile()"
                      ></button>
                    </span>
                  </div>

                </div>
                <div class="column">
                  <!-- Gambar 2 -->
                  <b-field label="Gambar News 2"
                    :type="form.picture1.type"
                    :message="form.picture1.message"> 
                      <b-upload v-model="form.picture1.value" @input="readImagePic1"  accept="image/*" drag-drop>
                        <section class="section">
                          <div class="content has-text-centered">
                            <p v-if="uploadPic1">
                              <b-icon icon="upload" size="is-medium">
                              </b-icon>
                            </p>
                            <p v-if="uploadPic1">
                              Drop your files here or click to upload
                            </p>
                            
                            <div class="image-preview" v-if="previewPic1">
                              <img class="preview" :src="gambarNewsPic1">
                            </div>
                            <div class="image-preview" v-if="previewEditPic1">
                              <img class="preview" :src="gambarNewsPic1">
                            </div>
                          </div>
                        </section>
                      </b-upload>
                  </b-field>

                  <div class="tags">
                    <span class="tag is-primary" v-if="previewPic1">
                      {{ form.picture1.value.name }}
                      <button
                        class="delete is-small"
                        type="button"
                        @click="deleteDropFilePic1()"
                      ></button>
                    </span>

                    <span class="tag is-primary" v-if="previewEditPic1">
                      {{ form.picture1.value }}
                      <button
                        class="delete is-small"
                        type="button"
                        @click="deleteDropFilePic1()"
                      ></button>
                    </span>
                  </div>
                </div>
                  <!-- Gambar 3 -->
                <div class="column">
                  <b-field label="Gambar News 3"
                    :type="form.picture2.type"
                    :message="form.picture2.message"> 
                      <b-upload v-model="form.picture2.value" @input="readImagePic2"  accept="image/*" drag-drop>
                        <section class="section">
                          <div class="content has-text-centered">
                            <p v-if="uploadPic2">
                              <b-icon icon="upload" size="is-medium">
                              </b-icon>
                            </p>
                            <p v-if="uploadPic2">
                              Drop your files here or click to upload
                            </p>
                            
                            <div class="image-preview" v-if="previewPic2">
                              <img class="preview" :src="gambarNewsPic2">
                            </div>
                            <div class="image-preview" v-if="previewEditPic2">
                              <img class="preview" :src="gambarNewsPic2">
                            </div>
                          </div>
                        </section>
                      </b-upload>
                  </b-field>

                  <div class="tags">
                    <span class="tag is-primary" v-if="previewPic2">
                      {{ form.picture2.value.name }}
                      <button
                        class="delete is-small"
                        type="button"
                        @click="deleteDropFilePic2()"
                      ></button>
                    </span>

                    <span class="tag is-primary" v-if="previewEditPic2">
                      {{ form.picture2.value }}
                      <button
                        class="delete is-small"
                        type="button"
                        @click="deleteDropFilePic2()"
                      ></button>
                    </span>
                  </div>
                </div>
              </div>
              </div>
            </div>
            <b-field label="Url Video Youtube" expanded 
            :type="form.url.type" 
            :message="form.url.message">
              <b-input name="url" @input="clearError(form.url)" v-model="form.url.value"></b-input>
            </b-field>
                <!-- <b-button rounded class="button is-primary" @click="confirm()">
                  Simpan
                </b-button> -->
          </div>
        </div>
        <div class="rows mt-24">
          <div class="row">
            <div class="columns">
              <div class="column">
                <b-button  class="button is-danger btn-block"
                  tag="router-link"
                  to="/biro/berandablog">
                  Kembali
                </b-button>
              </div>
              <div class="column">
                <button class="button is-success btn-block"
                @click="confirm()">
                Simpan
                </button>
              </div>
            </div>
          </div>          
        </div>
      </div>
    </div>
    <!-- <div class="box"> -->
      <b-loading 
          :is-full-page="true" 
          :active.sync="isLoading" 
          :can-cancel="false">
      </b-loading>   
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import Alignment from "@ckeditor/ckeditor5-alignment/src/alignment";
import Autoformat from "@ckeditor/ckeditor5-autoformat/src/autoformat";
import Autosave from "@ckeditor/ckeditor5-autosave/src/autosave";
import BlockQuote from "@ckeditor/ckeditor5-block-quote/src/blockquote";
import Bold from "@ckeditor/ckeditor5-basic-styles/src/bold";
import Essentials from "@ckeditor/ckeditor5-essentials/src/essentials";
import FontColor from "@ckeditor/ckeditor5-font/src/fontcolor";
import FontFamily from "@ckeditor/ckeditor5-font/src/fontfamily";
import FontSize from "@ckeditor/ckeditor5-font/src/fontsize";
//import Heading from "@ckeditor/ckeditor5-heading/src/heading";
import Highlight from "@ckeditor/ckeditor5-highlight/src/highlight";
import Indent from "@ckeditor/ckeditor5-indent/src/indent";
import IndentBlock from "@ckeditor/ckeditor5-indent/src/indentblock";
import Italic from "@ckeditor/ckeditor5-basic-styles/src/italic";
//image
// import Image from '@ckeditor/ckeditor5-image/src/image';
// import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
// import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
// import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
// import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';
import Link from "@ckeditor/ckeditor5-link/src/link";
import List from "@ckeditor/ckeditor5-list/src/list";
import ListStyle from "@ckeditor/ckeditor5-list/src/liststyle";
import Paragraph from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import PasteFromOffice from "@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice";
import Strikethrough from "@ckeditor/ckeditor5-basic-styles/src/strikethrough";
import Subscript from "@ckeditor/ckeditor5-basic-styles/src/subscript";
import Superscript from "@ckeditor/ckeditor5-basic-styles/src/superscript";
import Table from "@ckeditor/ckeditor5-table/src/table";
import TableCellProperties from "@ckeditor/ckeditor5-table/src/tablecellproperties";
import TableProperties from "@ckeditor/ckeditor5-table/src/tableproperties";
import TableToolbar from "@ckeditor/ckeditor5-table/src/tabletoolbar";
import Underline from "@ckeditor/ckeditor5-basic-styles/src/underline";
import WordCount from "@ckeditor/ckeditor5-word-count/src/wordcount";

export default {
  data() {
    return {
      editorData: "<p>Isi Content News</p>",
      editor: ClassicEditor,
      editorConfig: {
        plugins: [
          Alignment,
          Autoformat,
          Autosave,
          BlockQuote,
          Bold,
          Essentials,
          FontColor,
          FontFamily,
          FontSize,
          //Heading,
          Highlight,
          Indent,
          IndentBlock,
          Italic,
          // Image,
          // ImageCaption,
          // ImageStyle,
          // ImageToolbar,
          // ImageUpload,
          Link,
          List,
          ListStyle,
          Paragraph,
          PasteFromOffice,
          Strikethrough,
          Subscript,
          Superscript,
          Table,
          TableCellProperties,
          TableProperties,
          TableToolbar,
          Underline,
          WordCount,
        ],
        toolbar: [
          //"heading",
          "|",
          "undo",
          "redo",
          "|",
          "bold",
          "italic",
          "underline",
          "link",
          "bulletedList",
          "numberedList",
          "|",
          "alignment:left",
          "alignment:center",
          "alignment:right",
          "alignment:justify",
          "|",
          "indent",
          "outdent",
          "insertTable",
          "blockQuote",
          "|",
          "fontFamily",
          "fontColor",
          "fontSize",
          "highlight",
          "strikethrough",
          "subscript",
          "superscript"
        ],
        wordCount: {
          displayWords: true,
        },
        // The configuration of the editor.
      },
      isLoading: false,
      actionTitle: '',
      news:'',
      gambarNews:'',
      gambarNewsPic1:'',
      gambarNewsPic2:'',
      editId: 0, // Dibikin default 0 buat bedain dia edit data atau add data. Lebih jelasnya baca method confirm()
      dataNews: new FormData(), // Buat nampung isi form
      editDataNews: {}, // Buat nampung data yg mau diedit kalo ada
      form: {
        title: { value: '', type: '', message: '' },
        news: { value: '', type: '', message: '' },
        picture: { value: '', type: '', message: '' },
        picture1: { value: '', type: '', message: '' },
        picture2: { value: '', type: '', message: '' },
        url: { value: '', type: '', message: '' },
      },
      snackbarMsg: '',
      upload: true,
      preview: false,
      previewEdit: false,

       uploadPic1: true,
      previewPic1: '',
      previewEditPic1: '',

      uploadPic2: true,
      previewPic2: '',
      previewEditPic2: '',
      
      activeBiro:Object,
      config: {}
    };
  },
 
  methods: {
     youtubeParser(url){
      var video_id = url.split('v=')[1];
      var ampersandPosition = video_id.indexOf('&');
      if(ampersandPosition != -1) {
        video_id = video_id.substring(0, ampersandPosition);
      }
      return video_id
    },
    readImage(){
      var input = this.form.picture.value
      
      if(input){
        var reader = new FileReader()
        reader.readAsDataURL(input)
        reader.onload = (e) => {
          this.gambarNews = e.target.result
        }
      }
      this.upload = false
      this.preview = true
    },

    deleteDropFile() {
      this.form.picture.value = ''
      this.upload = true
      this.preview = false
      this.previewEdit = false
    },
    // picture1
    readImagePic1(){
      var input = this.form.picture1.value
      
      if(input){
        var reader = new FileReader()
        reader.readAsDataURL(input)
        reader.onload = (e) => {
          this.gambarNewsPic1 = e.target.result
        }
      }
      this.uploadPic1 = false
      this.previewPic1 = true
    },

    deleteDropFilePic1() {
      this.form.picture1.value = ''
      this.uploadPic1 = true
      this.previewPic1 = false
      this.previewEditPic1 = false
    },

    // picture2
    readImagePic2(){
      var input = this.form.picture2.value
      
      if(input){
        var reader = new FileReader()
        reader.readAsDataURL(input)
        reader.onload = (e) => {
          this.gambarNewsPic2 = e.target.result
        }
      }
      this.uploadPic2 = false
      this.previewPic2 = true
    },

    deleteDropFilePic2() {
      this.form.picture2.value = ''
      this.uploadPic2 = true
      this.previewPic2 = false
      this.previewEditPic2 = false
    },
    getData(editId) {
      var uri = this.$apiUrl + "news/" + editId

      this.$http.get(uri, this.config).then(response => {
        this.editDataNews = response.data.value
        this.formEditHandler(this.editDataNews) 
      })
    },
     getNewsByBiro()
      {
          var uri = this.$apiUrl + 'news/biro/' + this.detailId 
          this.$http.get(uri, this.config).then(response=>
          {
              this.news = response.data.value
          })
      },
    formEditHandler(dataNews) { 
      this.form.title.value = dataNews.title
      this.form.news.value = dataNews.news
      // this.form.url.value = dataNews.url
        if(dataNews.url !== null)
      {
        this.form.url.value = dataNews.url
      }
       if(dataNews.picture !== null){
          this.form.picture.value = dataNews.picture
          this.gambarNews = this.$apiUrl + 'news/picture/' + dataNews.picture
          this.upload = false
          this.previewEdit = true
      }
      if(dataNews.picture1 !== null){
          this.form.picture1.value = dataNews.picture1
          this.gambarNewsPic1 = this.$apiUrl + 'news/picture/' + dataNews.picture1
          this.uploadPic1 = false
          this.previewEditPic1 = true
      }
      if(dataNews.picture2 !== null){
          this.form.picture2.value = dataNews.picture2
          this.gambarNewsPic2 = this.$apiUrl + 'news/picture/' + dataNews.picture2
          this.uploadPic2 = false
          this.previewEditPic2 = true
      }

    },
    clearError(form) {
      console.log(form)
      form.type = ''
      form.message = '' 
    },
    cekData() {
      let count = 0

      if(this.form.title.value === "") {
        this.form.title.type = 'is-danger'
        this.form.title.message = "Judul Harus diisi!"
        count++
      }
      if(this.form.news.value === "") {
        this.form.news.type = 'is-danger'
        this.form.news.message = "Isi News harus diisi"
        count++
      } 
       if(this.form.picture.value === "") {
        this.form.picture.type = 'is-danger'
        this.form.picture.message = "Picture 1 harus diisi"
        count++
      } 
       if(this.form.picture.value.size > 2000000) {
        this.form.picture.type = 'is-danger'
        this.form.picture.message = "File Picture terlalu besar(max 2MB) "
        count++
      } 
      // if(this.form.url.value === "") {
      //   this.form.url.type = 'is-danger'
      //   this.form.url.message = "Url Video harus diisi"
      //   count++
      // } 

      console.log(count)

      if(count > 0)
        return false
    },
    addData() {
      this.isLoading = true // Biar dia loading dulu
      
      if(this.cekData() == false) {
        this.snackbar("Gagal tambah data. Silahkan Input Lagi...", 'is-danger')
        this.isLoading = false
      } else {

        console.log(this.form)
        
        this.dataNews.append("title", this.form.title.value)
        this.dataNews.append("news", this.form.news.value)
        this.dataNews.append("picture", this.form.picture.value)
        this.dataNews.append("picture1", this.form.picture1.value)
        this.dataNews.append("picture2", this.form.picture2.value)
        // this.dataNews.append("url", this.form.url.value)
        this.dataNews.append("id_biro", this.detailId)

        //  var video_id = this.youtubeParser(this.form.url.value)
        // var url_video = 'https://www.youtube.com/embed/' + video_id
        // this.dataNews.append("url", url_video)
        if(this.form.url.value !== "")
        {
            var video_id = this.youtubeParser(this.form.url.value)
            var url_video = 'https://www.youtube.com/embed/' + video_id
            this.dataNews.append("url", url_video)
        }else{
          this.dataNews.append("url", this.form.url.value)
        } 

       
        var uri = this.$apiUrl + "news";

        this.$http.post(uri, this.dataNews, this.config).then(response => {
          this.isLoading = false
          this.snackbarMsg = response.message
          this.$router.push({name: 'BerandaBlogBiro'})
          this.snackbar("Data berhasil ditambahkan", 'is-success')
        })
        .catch(error => {
          this.errors = error;
          this.isLoading = false
          if (this.errors.message == "Request failed with status code 400") {
            this.snackbar("Gagal tambah data.Silahkan Input Lagi", 'is-danger')
          } else {
            this.snackbar("Terjadi kesalahan. Silahkan coba lagi", 'is-danger')
          }
        })
      }
      // this.isLoading = false 
    },
    editData(editId) {
      this.isLoading = true 

      if(this.cekData() == false) {
        this.snackbar("Gagal tambah data. Sepertinya inputan salah...", 'is-danger')
        this.isLoading = false
      } else {
        this.dataNews.append("title", this.form.title.value)
        this.dataNews.append("news", this.form.news.value)
        // this.dataNews.append("url", this.form.url.value)
        this.dataNews.append("id_biro", this.detailId)

          if(this.form.url.value !== "" && this.form.url.value !== this.editDataNews.url)
        {
            var video_id = this.youtubeParser(this.form.url.value)
            var url_video = 'https://www.youtube.com/embed/' + video_id
            this.dataNews.append("url", url_video)
        }else{
          this.dataNews.append("url", this.form.url.value)
        } 
      
        if(typeof(this.form.picture.value) !== 'string') { 
          this.dataNews.append("picture", this.form.picture.value) 
        }else if(this.form.picture.value === ''){
           this.dataNews.append("picture", '') 
        }
        if(typeof(this.form.picture1.value) !== 'string'){          
          this.dataNews.append("picture1", this.form.picture1.value) 
          this.dataNews.append("change1", 1 )
        }else if(this.form.picture1.value === ''){
           this.dataNews.append("change1", 'no') 
        }
        if(typeof(this.form.picture2.value) !== 'string') { 
          this.dataNews.append("picture2", this.form.picture2.value) 
          this.dataNews.append("change2", 1 )
        }else if(this.form.picture2.value === ''){
           this.dataNews.append("change2", 'no') 
        }

       
        console.log(this.dataNews)

        var uri = this.$apiUrl + "news/" + editId;

        this.$http.post(uri, this.dataNews, this.config).then(response => {
          this.isLoadin = false
           this.$router.push( { name: 'BerandaBlogBiro' } )
          this.snackbarMsg = response.message
          this.snackbar("Data berhasil diedit", 'is-success')
        })
        .catch(error => {
          this.errors = error;
          this.isLoading = false
          if (this.errors.message == "Request failed with status code 400") {
            this.snackbar("Edit gagal. Sepertinya inputan salah...", 'is-danger')
          } else {
            this.snackbar("Terjadi kesalahan. Silahkan coba lagi", 'is-danger')
          }
        })
      }
      // this.isLoading = false // Biar berhenti loading
    },
    confirm() {
      this.editId == 0 ? this.addData() : this.editData(this.editId)
    },
    snackbar(snackbarMessage, type)
    {
      this.$buefy.toast.open({
        duration: 5000,
        message: snackbarMessage,
        type: type,
        position: 'is-top',
        actionText: 'OK',
        queue: false,
      })
    },

  },
  watch: {
    picture: function(o) {
      var reader = new FileReader();
      reader.onload = e => this.$emit("load", e.target.result);
      reader.readAsText(o[0]);
      alert();
    }
  },
   mounted() {
    //  this.getData()
    if(this.$session.exists()){
      this.config = {
        headers: {
          'Authorization': 'Bearer ' + this.$session.get('token')
        }
      }
    }
     this.activeBiro = this.$session.get('biro')
      if(this.activeBiro)
        {
        this.detailId = this.activeBiro.id_biro
        this.getNewsByBiro()
        // this.getSekolahByBiro()
        // this.getDataByBiro(this.detailId)
      }
            
    if(this.$route.params.id) {           
      this.editId = this.$route.params.id 
      this.actionTitle = 'Ubah'           
      this.getData(this.editId)          
    } else {                      
      this.actionTitle = 'Tambah' 
    }
    // this.isLoading = false 
  }
};
</script>

<style scoped>
  img.preview {
    width: 200px;
    background-color: white;
    border: 1px solid #DDD;
    padding: 5px;
  }
</style>